import React, { ReactNode, useEffect, useState } from 'react'
import { Color } from '../utils/constants'
import { FormattedMessage } from 'react-intl'
import PageHeader from '../partials/PageHeader'
import Separator from '../components/Separator'
import api from '../utils/api'
import parse from 'html-react-parser'
import { slug } from '../utils/helpers'
import FadeIn from '../components/Animation/FadeIn'

const PrivacyPolicy = () => {
    const [posts, setPosts] = useState<Record<string, ReactNode>>({})
    const [titles, setTitles] = useState<string[]>([])
    useEffect(() => {
        const getData = (object: any): string => {
            if (object.data) return object.data
            return getData(object.children[0])
        }

        const parseOptions = {
            // @ts-ignore
            replace: (domNode) => {
                // @ts-ignore
                if (domNode.name === 'h5') {
                    const data = getData(domNode)
                    setTitles((current) => [...current, data])
                    return <h5 id={slug(data)}>{data}</h5>
                }
            },
        }

        api.get('/wp-json/categories/v1/posts?name=privacy-policy').then((response) => {
            const fixDateForAllBrowsers = (dateString: string) => dateString.replace(/-/g, '/')
            const sortedPosts = response.data.sort(
                (
                    postA: { [x: string]: string | number | Date },
                    postB: { [x: string]: string | number | Date },
                ) => {
                    return (
                        new Date(fixDateForAllBrowsers(postA['post_date'] as string)).getTime() -
            new Date(fixDateForAllBrowsers(postB['post_date'] as string)).getTime()
                    )
                },
            )
            const parsedPosts = sortedPosts.reduce(
                (
                    allPosts: { [x: string]: string | JSX.Element | JSX.Element[] },
                    post: { [x: string]: any },
                ) => {
                    setTitles((current) => [...current, post['post_title']])
                    allPosts[post['post_title']] = parse(post?.['post_content'] ?? '', parseOptions)
                    return allPosts
                },
        {} as Record<string, ReactNode>,
            )
            setPosts(parsedPosts)
        })
    }, [])

    return (
        <FadeIn>
            <div>
                <PageHeader bgColor={Color.WHITE} link={'/'}>
                    <></>
                </PageHeader>
                <div className='side-padding-md 3xl:max-w-screen-2xl mx-auto'>
                    <div className='py-24'>
                        <FormattedMessage id={'page.privacy'} tagName='h1' />
                        <Separator className='my-16' />
                    </div>
                    <div className='grid gap-x-24' style={{ gridTemplateColumns: '315px auto' }}>
                        <div className='md:flex flex-col gap-y-4 sticky top-40 self-start hidden'>
                            {titles.map((title) => (
                                <button
                                    key={title}
                                    onClick={() => {
                                        const element = document.querySelector(`#${slug(title)}`)
                    element?.scrollIntoView({ behavior: 'smooth' })
                                    }}
                                    className='text-left'
                                >
                                    {title}
                                </button>
                            ))}
                        </div>
                        <div className='privacy-policy--post max-w-[630px]'>
                            {Object.entries(posts).map(([title, post]) => (
                                <div key={`policy-${title}`}>
                                    <h4 className='pb-6' id={slug(title)}>
                                        {title}
                                    </h4>
                                    {post}
                                    <Separator className='my-10' />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </FadeIn>
    )
}

export default PrivacyPolicy
